export interface CameraSnapshot {
  readonly position: readonly [number, number, number];
  readonly target: readonly [number, number, number];
  readonly zoom: number;
}

export interface CameraSnapshots {
  readonly 2: CameraSnapshot;
  readonly 3: CameraSnapshot;
}

export const DEFAULT_CAMERA_SNAPSHOTS: CameraSnapshots = {
  2: { position: [0, 0, 10], target: [0, 0, 0], zoom: 1 },
  3: { position: [7, 7, 7], target: [0, 0, 0], zoom: 1 },
};

export function cloneCameraSnapshots(
  snapshots: CameraSnapshots,
): CameraSnapshots {
  return {
    2: {
      position: [...snapshots[2].position],
      target: [...snapshots[2].target],
      zoom: snapshots[2].zoom,
    },
    3: {
      position: [...snapshots[3].position],
      target: [...snapshots[3].target],
      zoom: snapshots[3].zoom,
    },
  };
}

export function createDefaultCameraSnapshots(): CameraSnapshots {
  return cloneCameraSnapshots(DEFAULT_CAMERA_SNAPSHOTS);
}
